<template>
  <div class="wrapper">
    <!-- 메인팝업 import-->
    <div class="backdrop">
      <div class="popup-container"></div>
    </div>

    <!-- 메인에서 헤더 css가 달라져 분리 -->
    <main v-if="isMain">
      <div class="header-wrap">
        <ResponsiveSubMenu v-if="$route.meta?.navMenu" />
      </div>
      <div ref="container">
        <router-view />
      </div>
    </main>

    <template v-else>
      <div class="header-wrap">
        <ResponsiveHeader v-if="!isMain" :logo="1" />
        <ResponsiveSubMenu v-if="$route.meta?.navMenu" />
      </div>
      <main>
        <div ref="container">
          <router-view />
        </div>
      </main>
    </template>

    <MQuickMenu />
    <ResponsiveFooter />
    <MAlertDialog />
    <MConfirmDialog />
    <MainPopup v-if="commonStore.isMobile" />
    <MModal ref="modal" @close="handleCloseModal">
      <template #modal-body>
        <Login @signIn="handleSignInComplete" />
      </template>
    </MModal>
    <Loading />
  </div>
</template>
<script setup lang="ts">
import ResponsiveHeader from '@components/common/responsive/ResponsiveHeader.vue';
import ResponsiveFooter from '@components/common/responsive/ResponsiveFooter.vue';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useCommonStore } from '@stores';
import { MAlertDialog, MConfirmDialog, MModal, MQuickMenu } from '@molecules';
import Login from '@views/main/desktop/SignIn.vue';
import ResponsiveSubMenu from '@components/common/responsive/ResponsiveSubMenu.vue';
import router from '@infra/router';
import { ROUTE_NAME } from '@constants';
import MainPopup from '@infra/components/common/MainPopup.vue';
import Loading from '@components/common/Loading.vue';

// const header = ref<HTMLElement>();
// const footer = ref<HTMLElement>();
// const mobileHeader = ref<HTMLElement | null>(null);
// const desktopHeader = ref<HTMLElement | null>(null);
// const mobileFooter = ref<HTMLElement | null>(null);
// const desktopFooter = ref<HTMLElement | null>(null);
const container = ref<HTMLElement>();
const commonStore = useCommonStore();
const modal = ref();

const isMain = computed(() => {
  return router.currentRoute.value.name === ROUTE_NAME.Main;
});

const handleSignInComplete = (isComplete: boolean) => {
  if (isComplete) {
    modal.value.close();
  }
};
const adjustContainerHeight = async () => {
  if (!container.value) return;
  // const headerHeight = header.value?.offsetHeight || 0;
  // const footerHeight = footer.value?.offsetHeight || 0;
  // const headerHeight = commonStore.isMobile
  //   ? mobileHeader.value?.offsetHeight || 0
  //   : desktopHeader.value?.offsetHeight || 0;

  // const footerHeight = commonStore.isMobile
  //   ? mobileFooter.value?.offsetHeight || 0
  //   : desktopFooter.value?.offsetHeight || 0;

  // container.value.style.minHeight = `calc(100vh - ${headerHeight + footerHeight}px)`;
};

onMounted(() => {
  adjustContainerHeight();
  window.addEventListener('resize', adjustContainerHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', adjustContainerHeight);
});

const handleCloseModal = () => {
  commonStore.setSigninOpen(false);
};
watch(
  () => commonStore.isSigninOpen,
  (isSigninOpen: boolean) => {
    if (isSigninOpen && modal.value) {
      modal.value.open();
    }
    if (!isSigninOpen && modal.value) {
      modal.value.close();
    }
  },
  {
    immediate: true,
  }
);
</script>

<style scoped lang="scss">
main {
  display: block;
  width: 100%;
  min-height: calc(100vh - 420px);
  position: relative;
}

@media (max-width: 884px) {
  main {
    min-height: 100%;
  }
}
</style>
